import { render, staticRenderFns } from "./NewService.vue?vue&type=template&id=b1fa5962&scoped=true&"
import script from "./NewService.vue?vue&type=script&lang=js&"
export * from "./NewService.vue?vue&type=script&lang=js&"
import style0 from "./NewService.vue?vue&type=style&index=0&id=b1fa5962&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fa5962",
  null
  
)

export default component.exports